import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LogoMark } from "@/components/Logo";

const CHECKS = [
  "UPTIME MONITOR",
  "ALERT PIPELINE",
  "DEPLOY GATEWAY",
  "JISLL CORE",
];

const EASE = [0.76, 0, 0.24, 1];

export default function Preloader({ onComplete }) {
  const [step, setStep] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (step < CHECKS.length) {
      const t = setTimeout(() => setStep((s) => s + 1), step === 0 ? 320 : 230);
      return () => clearTimeout(t);
    }
    const t1 = setTimeout(() => setDone(true), 420);
    const t2 = setTimeout(onComplete, 620);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [step, onComplete]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100]"
          exit={{ opacity: 1 }}
        >
          <motion.div
            className="absolute inset-x-0 top-0 h-1/2 bg-paper"
            exit={{ y: "-101%" }}
            transition={{ duration: 0.9, ease: EASE }}
          />
          <motion.div
            className="absolute inset-x-0 bottom-0 h-1/2 bg-paper"
            exit={{ y: "101%" }}
            transition={{ duration: 0.9, ease: EASE }}
          />
          <motion.div
            className="absolute inset-0 flex items-center justify-center"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            <div className="w-[min(90vw,340px)]">
              <div className="mb-8 flex items-center gap-3">
                <LogoMark className="h-9 w-9 text-ink" />
                <div>
                  <p className="font-heading text-lg font-extrabold tracking-tight text-ink">
                    JISLL
                  </p>
                  <p className="font-mono text-[9px] uppercase tracking-[0.22em] text-slate-500">
                    Technology Services
                  </p>
                </div>
              </div>
              <div className="space-y-2">
                {CHECKS.map((label, i) => (
                  <div
                    key={label}
                    className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.18em]"
                  >
                    <span className={i < step ? "text-slate-700" : "text-slate-300"}>
                      {label}
                    </span>
                    <span
                      className={
                        i < step ? "text-emerald-600" : "text-slate-300"
                      }
                    >
                      {i < step ? "OK" : "···"}
                    </span>
                  </div>
                ))}
              </div>
              <div className="mt-8 h-px w-full bg-slate-200">
                <motion.div
                  className="h-px bg-brand"
                  initial={{ width: "0%" }}
                  animate={{ width: `${(Math.min(step, CHECKS.length) / CHECKS.length) * 100}%` }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                />
              </div>
              {step >= CHECKS.length && (
                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.18em] text-brand">
                  100% operational
                </p>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
